export const getRiskMatrixValue = (impact, probability) => {
    const matrix = {
        5: { A: 'M', B: 'M', C: 'H', D: 'H', E: 'VH' },
        4: { A: 'L', B: 'M', C: 'M', D: 'H', E: 'H' },
        3: { A: 'N', B: 'L', C: 'M', D: 'M', E: 'H' },
        2: { A: 'N', B: 'N', C: 'L', D: 'M', E: 'M' },
        1: { A: 'N', B: 'N', C: 'N', D: 'L', E: 'L' },
        0: { A: 'N', B: 'N', C: 'N', D: 'N', E: 'N' },
    };

    return matrix?.[impact]?.[probability] || '';
};